// Relocation Guides Data - JSON-based CMS
// Edit this file to add/update relocation content

// Hero carousel slides - daylight urban sophistication
export const heroSlides = [
  {
    type: 'image',
    url: 'https://images.unsplash.com/photo-1648147145924-2b4e2e8d896e?q=80&w=2000&auto=format&fit=crop',
    alt: 'Mexico City La Condesa skyline view'
  },
  {
    type: 'image',
    url: 'https://images.unsplash.com/photo-1759255260844-0466c096de0f?q=80&w=2000&auto=format&fit=crop',
    alt: 'Modern CDMX cityscape with parks'
  },
  {
    type: 'image',
    url: 'https://images.unsplash.com/photo-1759255261348-9414ee167cb4?q=80&w=2000&auto=format&fit=crop',
    alt: 'Panoramic view of Mexico City'
  },
  {
    type: 'image',
    url: 'https://images.unsplash.com/photo-1601252995551-08174f89efb4?q=80&w=2000&auto=format&fit=crop',
    alt: 'Colonial architecture in Mexico City'
  }
];

// Resource blocks with images
export const relocationResources = [
  {
    id: 'housing',
    title: 'Housing & Neighborhoods',
    description: 'Find your ideal neighborhood from Polanco to Roma.',
    slug: 'housing',
    image: 'https://images.unsplash.com/photo-1637011622402-e2efe6e08d71?q=80&w=800&auto=format&fit=crop'
  },
  {
    id: 'visas',
    title: 'Visas & Residency',
    description: 'Navigate temporary and permanent residency options.',
    slug: 'visas',
    image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=800&auto=format&fit=crop'
  },
  {
    id: 'schools',
    title: 'Schools & Family',
    description: 'International and bilingual school options.',
    slug: 'schools',
    image: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?q=80&w=800&auto=format&fit=crop'
  },
  {
    id: 'healthcare',
    title: 'Healthcare',
    description: 'World-class hospitals and insurance options.',
    slug: 'healthcare',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=800&auto=format&fit=crop'
  },
  {
    id: 'banking',
    title: 'Banking & Setup',
    description: 'Bank accounts, taxes, and financial setup.',
    slug: 'banking',
    image: 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?q=80&w=800&auto=format&fit=crop'
  },
  {
    id: 'checklist',
    title: '30-Day Checklist',
    description: 'Step-by-step timeline for your relocation.',
    slug: 'checklist',
    image: 'https://images.unsplash.com/photo-1618080930129-382666bd9530?q=80&w=800&auto=format&fit=crop'
  }
];

export const relocationPackages = [
  {
    id: 'digital',
    tag: 'RELO-DIGITAL',
    name: 'Digital Relocation Plan',
    price: '$199',
    amount: 199,
    description: 'Self-guided relocation with structured planning tools.',
    features: [
      'Complete relocation checklist',
      'Neighborhood guide and selection framework',
      'Housing search strategy',
      'Visa and residency planning guide',
      'Banking and tax setup guide',
      'Trusted providers directory',
      '7 days email support'
    ]
  },
  {
    id: 'guided',
    tag: 'RELO-GUIDED',
    name: 'Guided Relocation Plan',
    price: '$999',
    amount: 999,
    description: 'Structured planning with direct advisory support.',
    features: [
      'Everything in Digital Plan',
      '60 minute strategy call',
      'Neighborhood shortlist based on profile',
      'School guidance and recommendations',
      'Rental search support and agent introductions',
      'Partner introductions (attorneys, accountants)',
      '30 days support'
    ]
  },
  {
    id: 'white-glove',
    tag: 'RELO-WHITE',
    name: 'White Glove Relocation',
    price: '$4,500',
    amount: 4500,
    description: 'Full-service relocation with concierge execution.',
    features: [
      'Everything in Guided Plan',
      'Housing coordination and virtual tours',
      'Vendor scheduling and coordination',
      'Lease review and coordination',
      'Arrival concierge service',
      'Move-in coordination',
      '90 days support'
    ]
  }
];

export const neighborhoods = [
  { 
    id: 'polanco',
    name: 'Polanco', 
    type: 'Upscale, international',
    description: 'Mexico City\'s most prestigious neighborhood. Home to embassies, luxury boutiques, and world-class restaurants. Excellent for families with international schools nearby.',
    priceRange: '$$$',
    bestFor: ['Families', 'Executives', 'International community']
  },
  { 
    id: 'roma',
    name: 'Roma', 
    type: 'Arts, dining, walkable',
    description: 'Tree-lined streets, art deco architecture, and a vibrant food scene. Popular with creatives and young professionals.',
    priceRange: '$$',
    bestFor: ['Young professionals', 'Creatives', 'Foodies']
  },
  { 
    id: 'condesa',
    name: 'Condesa', 
    type: 'Bohemian, parks, cafes',
    description: 'Green spaces, outdoor cafes, and a relaxed atmosphere. Adjacent to Roma with excellent walkability.',
    priceRange: '$$',
    bestFor: ['Digital nomads', 'Pet owners', 'Outdoor enthusiasts']
  },
  { 
    id: 'lomas',
    name: 'Lomas de Chapultepec', 
    type: 'Residential, families',
    description: 'Quiet, residential neighborhood with large homes and gardens. Excellent schools and family amenities.',
    priceRange: '$$$',
    bestFor: ['Families', 'Privacy seekers', 'Long-term residents']
  },
  { 
    id: 'del-valle',
    name: 'Del Valle', 
    type: 'Central, mixed use',
    description: 'Affordable central location with good transit access. Mix of residential and commercial.',
    priceRange: '$',
    bestFor: ['Budget-conscious', 'Commuters', 'First-time relocators']
  },
  { 
    id: 'santa-fe',
    name: 'Santa Fe', 
    type: 'Modern, corporate',
    description: 'Business district with modern high-rises, shopping centers, and corporate offices. Less traditional but very convenient.',
    priceRange: '$$',
    bestFor: ['Corporate relocations', 'Modern amenities seekers']
  }
];

export const relocationFaqs = [
  {
    q: 'Are relocation fees credited toward representation?',
    a: 'Relocation fees may be credited toward representation if we assist with your lease or purchase. This is discussed during your intake call.'
  },
  {
    q: 'How long does the relocation process take?',
    a: 'Most relocations require 60-90 days of planning before arrival. White Glove clients typically complete setup within 30 days of arrival.'
  },
  {
    q: 'Do you help with rentals?',
    a: 'Yes. Guided and White Glove plans include rental search support and trusted agent introductions.'
  },
  {
    q: 'Do you work with families?',
    a: 'Yes. We provide school guidance, family housing recommendations, and family-specific planning support.'
  },
  {
    q: 'Do you assist with residency applications?',
    a: 'We provide residency planning guidance and connect you with qualified immigration attorneys. We do not file applications directly.'
  }
];

// Relocation Hub sub-pages content
export const relocationPages = {
  checklist: {
    title: 'Relocation Checklist',
    slug: 'checklist',
    description: 'Step-by-step timeline for your Mexico relocation.',
    heroImage: 'https://images.unsplash.com/photo-1618080930129-382666bd9530?q=80&w=2000&auto=format&fit=crop',
    phases: [
      {
        title: '90 Days Before',
        items: [
          'Research visa requirements and begin application',
          'Evaluate neighborhoods and shortlist options',
          'Connect with relocation advisor',
          'Begin remote job/income documentation',
          'Research schools (if applicable)'
        ]
      },
      {
        title: '60 Days Before',
        items: [
          'Schedule visa appointment at consulate',
          'Arrange temporary housing for first 30 days',
          'Open international bank account or get travel cards',
          'Research health insurance options',
          'Begin shipping/storage arrangements'
        ]
      },
      {
        title: '30 Days Before',
        items: [
          'Confirm visa approval',
          'Book flights and initial accommodation',
          'Notify banks and update addresses',
          'Arrange pet transport (if applicable)',
          'Connect with property agents for long-term housing'
        ]
      },
      {
        title: 'First Week',
        items: [
          'Complete immigration check-in (INM)',
          'Get local SIM card and phone plan',
          'Open Mexican bank account',
          'Register with embassy (optional)',
          'Begin neighborhood exploration'
        ]
      },
      {
        title: 'First Month',
        items: [
          'Secure long-term housing',
          'Set up utilities and services',
          'Get RFC (tax ID) if working locally',
          'Register with healthcare provider',
          'Build local network and routines'
        ]
      }
    ]
  },
  housing: {
    title: 'Housing & Neighborhoods',
    slug: 'housing',
    description: 'Find your ideal neighborhood and housing in Mexico City.',
    heroImage: 'https://images.unsplash.com/photo-1637011622402-e2efe6e08d71?q=80&w=2000&auto=format&fit=crop',
    content: 'Detailed neighborhood guides and housing search strategy.'
  },
  visas: {
    title: 'Visas & Residency',
    slug: 'visas',
    description: 'Navigate Mexican visa requirements and residency options.',
    heroImage: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?q=80&w=2000&auto=format&fit=crop',
    visaTypes: [
      {
        name: 'Tourist Visa (FMM)',
        duration: 'Up to 180 days',
        requirements: ['Valid passport', 'Return ticket', 'Proof of funds'],
        notes: 'Cannot work legally. Good for scouting trips.'
      },
      {
        name: 'Temporary Resident',
        duration: '1-4 years',
        requirements: [
          'Proof of income ($2,500+ USD/month) or savings',
          'Valid passport',
          'Consulate appointment',
          'Background check'
        ],
        notes: 'Most common for relocators. Can work with permit.'
      },
      {
        name: 'Permanent Resident',
        duration: 'Indefinite',
        requirements: [
          '4 years as Temporary Resident, OR',
          'Family ties to Mexican citizen, OR',
          'Retirement income qualification'
        ],
        notes: 'Full work authorization. Path to citizenship.'
      }
    ]
  },
  schools: {
    title: 'Schools & Education',
    slug: 'schools',
    description: 'International and bilingual school options for families.',
    heroImage: 'https://images.unsplash.com/photo-1580582932707-520aed937b7b?q=80&w=2000&auto=format&fit=crop',
    schoolTypes: [
      {
        type: 'International Schools',
        description: 'American or British curriculum. English instruction.',
        examples: ['American School Foundation', 'Greengates School', 'The Churchill School'],
        priceRange: '$15,000-30,000 USD/year'
      },
      {
        type: 'Bilingual Schools',
        description: 'Mexican curriculum with strong English program.',
        examples: ['Colegio Vista Hermosa', 'Instituto Westhill'],
        priceRange: '$8,000-15,000 USD/year'
      },
      {
        type: 'Mexican Private Schools',
        description: 'Spanish instruction, Mexican curriculum.',
        examples: ['Various options by neighborhood'],
        priceRange: '$3,000-8,000 USD/year'
      }
    ]
  },
  healthcare: {
    title: 'Healthcare',
    slug: 'healthcare',
    description: 'Navigate Mexico\'s healthcare system and insurance options.',
    heroImage: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=2000&auto=format&fit=crop',
    options: [
      {
        name: 'Private Insurance',
        description: 'International or Mexican private insurance for premium care.',
        providers: ['GNP', 'AXA', 'Cigna Global', 'Allianz'],
        cost: '$100-500 USD/month depending on coverage'
      },
      {
        name: 'IMSS (Public)',
        description: 'Mexican social security healthcare. Available to legal workers.',
        cost: 'Included with employment or ~$500 USD/year voluntary'
      },
      {
        name: 'Out of Pocket',
        description: 'Many expats pay directly for excellent private care.',
        notes: 'Doctor visits: $30-80. Specialists: $60-150.'
      }
    ]
  },
  banking: {
    title: 'Banking & Finance',
    slug: 'banking',
    description: 'Set up banking, taxes, and financial accounts in Mexico.',
    heroImage: 'https://images.unsplash.com/photo-1554224154-26032ffc0d07?q=80&w=2000&auto=format&fit=crop',
    topics: [
      {
        title: 'Mexican Bank Accounts',
        content: 'Most expats open accounts at BBVA, Santander, or Banorte. Requirements: passport, proof of address, RFC (tax ID) for some accounts.'
      },
      {
        title: 'International Options',
        content: 'Wise, Charles Schwab, and Mercury offer USD accounts with good Mexican ATM access.'
      },
      {
        title: 'Tax Considerations',
        content: 'Mexico taxes worldwide income for residents. Consult a cross-border tax professional.'
      }
    ]
  }
};

// Helper functions
export const getPackageById = (id) => {
  return relocationPackages.find(p => p.id === id);
};

export const getNeighborhoodById = (id) => {
  return neighborhoods.find(n => n.id === id);
};

export const getRelocationPage = (slug) => {
  return relocationPages[slug];
};

export const getResourceBySlug = (slug) => {
  return relocationResources.find(r => r.slug === slug);
};
